import styled, { css } from 'styled-components';

export const InputsWrapper = styled.fieldset`
  background: #fff;
  border: 1px solid #dfe3ec;
  box-sizing: border-box;
  box-shadow: 0px 2px 8px #c8ccd5;
  padding: 10px 16px;
  margin-top: 2px;
  position: absolute;
  z-index: 1;
  ${({ position }) =>
    position === 'right'
      ? css`
          right: 0px;
        `
      : css`
          left: 0px;
        `}
  legend {
    display: none;
  }
  div {
    margin: 4px 0px;
    font-size: 14px;
    color: #33373d;
    height: max-content;
    display: flex;
    width: max-content;
  }
`;

export const InputGroup = styled.div`
  margin: 4px 0px;
  font-size: 14px;
  color: #33373d;
  height: 16px;
  display: flex;
  align-items: center;
  position: relative;
  input {
    display: block;
    min-height: 16px;
    min-width: 16px;
    appearance: none;
    border: 2px solid #dfe3ec;
    border-radius: 50%;
    outline: none;
    transition-duration: 0.2s;
    background-color: #fff;
    cursor: pointer;
    margin-right: 5px;
  }
  input[type='checkbox'] {
    border-radius: 2px;
  }
  input[type='checkbox']:checked {
    background: #0095ff;
    border-radius: 2px;
  }
  input[type='checkbox']:checked + label::before {
    content: '';
    position: absolute;
    top: 4px;
    left: 2px;
    border-left: 2px solid #fff;
    border-bottom: 2px solid #fff;
    height: 5px;
    width: 10px;
    transform: rotate(-45deg);
  }
  input:checked {
    border: 5px solid #0095ff;
    background-color: #fff;
  }
  label {
    margin: 0;
    cursor: pointer;
    width: 100%;
  }
`;

export const HorizontalRule = styled.div`
  display: block !important;
  border: 2px solid #7367ee;
  width: 100% !important;
  height: 0px !important;
  margin-top: 8px !important;
`;

export const AdditionalInformation = styled.div`
  width: 100% !important;
  display: block !important;
`;
